<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch("utils/setSectionName", "Dashboard");
    this.$store.dispatch("sidebar/setAction", null);
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/DashboardPage.vue